<template>
  <div class="downloadCode">
    <div class="campus">
      激活码管理
      <span>></span>下载码
    </div>
    <div>
      <el-card>
        <div class="grid-content bg-purple scrollbarStyle shengchengma" style="height: 85vh; overflow: auto">
          <div class="header">下载码</div>
          <!-- 头部条件 -->
          <div class="dz-flex dz-flex-justify-space ">
            <div class="sousuo dz-flex dz-flex-align-center ">
              <span>书本：</span>
              <el-select v-model="bookId" clearable>
                <el-option v-for="(item, index) in bookList" :value="item.id" :label="item.name" :key="index" @click.native="book=item.name">{{item.name}}</el-option>
              </el-select>
              <span class="ml-30">下载次数：</span>
              <el-input placeholder="请输入下载次数" v-model="downloadnum" maxlength="4" clearable></el-input>
              <span class="ml-30">激活码有效期：</span>
              <el-select v-model="validday" clearable>
                <el-option v-for="(item, index) in timeList" :value="item.day" :label="item.name" :key="index" @click.native="timeName=item.name">{{item.name}}</el-option>
              </el-select>
              <el-button type="primary" class=" ml-25" @click="addActiveCode">生成</el-button>
            </div>
            <div class="sousuo">
              <span> 激活码： </span>
              <el-input @keyup.13.native="getCodeList" placeholder="请输入激活码" v-model="code"></el-input>
              <el-button type="primary" class="ml-30 px-20" @click="getCodeList">
                查 询
              </el-button>
            </div>
          </div>
          <!-- 头部条件 -->
          <div class="criteria">
            <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="swithStatus" active-text-color="#00ABEE" text-color="#666666">
              <el-menu-item index="1">已分发</el-menu-item>
              <el-menu-item index="0">未分发</el-menu-item>
            </el-menu>
          </div>
          <div>
            <div class="tableStyle">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column label="二维码" align="center">
                  <template slot-scope="scope">
                    <img class="dz-cur" style="width:80px;height:80px" :src="scope.row.downloadqrcodeurl" alt="" @click="getBig(scope.row.downloadqrcodeurl)">
                  </template>
                </el-table-column>
                <el-table-column prop="code" label="激活码" align="center"></el-table-column>
                <el-table-column prop="bookName" label="书名" align="center"></el-table-column>
                <el-table-column prop="downloadnum" label="可下载次数" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" align="center">
                  <template slot-scope="scope">
                    <span>{{scope.row.status===0?'未分发':'已分发'}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" v-if="isHandle">
                  <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="generateQrCode(scope.row)" v-if="!scope.row.downloadqrcodeurl">生成二维码</el-button>
                    <el-button type="success" size="mini" @click="distribute(scope.row)" v-if="scope.row.downloadqrcodeurl">分发</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="dz-flex dz-flex-justify-end mt-12">
              <el-pagination class="fenye_jihuo" background @size-change="getCodeList" @current-change="getCodeList" :current-page.sync="page" :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="dialogStyle">
      <el-dialog title="确认生成" :visible.sync="addDialog" width="600px" center>
        <div class="form_1 form_1_1">
          <el-row class="chakanss">
            <el-col :span="12">
              <div class="grid-content bg-purple">
                书本：
                <span>{{ book }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                激活码有效期：
                <span>{{ timeName }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="chakanss mt-20">
            <el-col :span="12">
              <div class="grid-content bg-purple">
                下载次数：
                <span>{{ downloadnum }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitAdd">
            确定
          </el-button>
          <el-button @click="addDialog = false">取消</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 放大功能 -->
    <el-dialog :visible.sync="dialogBig" width="500px">
      <div class="dz-flex-center">
        <img style="width:300px;height:300px" :src="dialogImageUrl" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { $getDownloadCodeList, $getDownLoadTimeList, $getDownloadQr, $addDownloadCode, $distribute } from '@/api/code';
import { $debounce } from '@/utils/index';
export default {
  name: 'downloadCode',
  data() {
    return {
      bookId: '',
      book: '',
      downloadnum: '',
      validday: '',
      timeName: '',
      timeList: [],
      bookList: [],
      code: '',
      //已使用 未使用
      activeIndex: '0',
      status: '0',
      tableData: [],

      pageSize: 10,
      page: 1,
      total: 1,
      addDialog: false,
      isHandle: false,
      dialogBig: false,

      dialogImageUrl: '',
    };
  },
  created() {
    this.$nextTick(() => {
      // 获取激活码列表
      this.getCodeList();
      // 获取下载时间列表
      this.getTimeList();
      // 获取书本列表
      this.getBookList();
    });
  },
  methods: {
    // 切换状态
    swithStatus(key) {
      this.status = key;
      this.getCodeList();
    },
    // 获取激活码列表
    async getCodeList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/downloadCode/getDownloadCodeList?' + 'page=' + this.page + '&pageSize=' + this.pageSize + '&status=' + this.status + '&code=' + this.code,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          this.tableData = res.data.data;
          this.total = res.data.size;
          +this.tableData[0].status === 0 ? (this.isHandle = true) : (this.isHandle = false);
          if (res.data.code !== 0) {
            return this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err)
        });
      // let data = {
      //   page: this.page,
      //   pageSize: this.pageSize,
      //   status: this.status,
      //   code: this.code,
      // };
      // const res = await $getDownloadCodeList(data);
      // if (res.data.code === 0) {
      //   this.tableData = res.data.data;
      //   this.total = res.data.size;
      //   +this.tableData[0].status === 0 ? (this.isHandle = true) : (this.isHandle = false);
      // }
    },
    // 获取下载时间列表
    async getTimeList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/downloadCode/getDownLoadTimeList',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: {},
      });
      pro
        .then((res) => {
          this.timeList = res.data.data;
          if (res.data.code !== 0) {
            return this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err)
        });
      // const res = await $getDownLoadTimeList();
      // if (res.data.code === 0) {
      //   this.timeList = res.data.data;
      // }
    },
    // 获取书本列表
    async getBookList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/downloadCode/findBookList',
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: {},
      });
      pro
        .then((res) => {
          this.bookList = res.data.data;
          if (res.data.code !== 0) {
            return this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          // console.log(err)
        });
      // const res = await $getDownLoadTimeList();
      // if (res.data.code === 0) {
      //   this.timeList = res.data.data;
      // }
    },
    addActiveCode() {
      if (this.bookId === '') {
        return this.$message.error('请选择书本！');
      }
      if (this.downloadnum === '' || +this.downloadnum > 1000) {
        return this.$message.error('下载次数不能为空或大于1000！');
      }
      if (this.validday === '') {
        return this.$message.error('激活码有效期未选择！');
      }
      this.addDialog = true;
    },
    // 生成激活码
    submitAdd: $debounce(async function () {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/downloadCode/addDownloadCode',
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: {
          bookId: this.bookId,
          validday: this.validday,
          downloadnum: this.downloadnum,
        },
      });
      pro
        .then((res) => {
          this.addDialog = false;
          if (res.data.code !== 0) {
            return this.$message.error(res.data.message);
          }
          this.$message.success(res.data.message);
          this.getCodeList();
        })
        .catch((err) => {
          // console.log(err)
        });
      // let data = {
      //   newTotal: this.creatNum,
      //   validday: this.validday,
      //   downloadnum: this.downloadnum,
      // };
      // const res = await $addDownloadCode(data);
      // if (res.data.code === 0) {
      //   this.$message.success(res.data.message);
      //   this.getCodeList();
      // } else {
      //   this.$message.warning(res.data.message);
      // }
      // this.addDialog = false;
    }, 500),
    // 生成二维码
    async generateQrCode(row) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/downloadCode/getDownloadQr?code=' + row.code,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((res) => {
          if (res.data.code !== 0) {
            return this.$message.error(res.data.message);
          }
          this.$message.success(res.data.message);
          this.getCodeList();
        })
        .catch((err) => {
          // console.log(err)
        });
      // const res = await $getDownloadQr({ code: row.code });
      // if (res.data.code === 0) {
      //   this.$message.success('生成二维码成功!');
      //   this.getCodeList();
      // } else {
      //   this.$message.warning(res.data.message);
      // }
    },
    // 分发
    distribute: $debounce(async function (row) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/downloadCode/distributeDownloadCode?id=' + row.id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: {
          id: row.id,
        },
      });
      pro
        .then((res) => {
          if (res.data.code !== 0) {
            return this.$message.error(res.data.message);
          }
          this.$message.success(res.data.message);
          this.getCodeList();
        })
        .catch((err) => {
          // console.log(err)
        });
      // const res = await $distribute({ id: row.id });
      // if (res.data.code === 0) {
      //   this.$message.success(res.data.message);
      //   this.getCodeList();
      // } else {
      //   this.$message.warning(res.data.message);
      // }
    }, 500),
    // 放大功能
    getBig(url) {
      if (url) {
        this.dialogBig = true;
        this.dialogImageUrl = url;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.downloadCode {
  .sousuo {
    margin-bottom: 30px;
    .el-input {
      width: 200px;
    }
    .el-select {
      width: 150px;
    }
    .el-date-editor {
      width: 220px;
    }
  }
  .sousuo .el-range-editor.el-input__inner {
    padding: 0;
  }
  .sousuo .el-date-editor {
    .el-range__icon {
      margin-left: 15px;
      margin-top: -4px;
    }
  }
}
</style>